export default {
  layout: {
    aiCommandCentre: {
      badge: 'AI Command Centre',
      line:
        'Autonomous carrier & driver allocation, agentic route planning, intelligent alerts & AI Agents — one control tower that runs logistics for you.',
      cta: 'AI Agents',
    },
  },
};
